<template>
  <div class="mb-3">

    <!-- Seleccionar empresa -->
    <b-form-group>
      <label for="width">Seleccionar empresa </label>
      <el-select v-model="filter.company.id" filterable remote clearable no-data-text="No hay datos que coincidan"
        no-match-text="No hay datos que coincidan" @change="onChangeCompany" :remote-method="onHandleSearchCompany"
        :loading="globalLoading">
        <el-option v-for="company in companies" :key="company.id" :label="company.nombre" :value="company.id">
        </el-option>
      </el-select>
    </b-form-group>

    <!-- Seleccionar ubicaciones -->
    <b-form-group v-if="filter.company.id">
      <label for="locations" class="mt-2">
        Ubicaciones del producto
      </label>
      <treeselect :value="valueLocations" :defaultExpandLevel="Infinity" 
        :normalizer="normalizerLocations" :multiple="true" :options="locations" placeholder="Ubicaciones del producto"
        name="locations" v-model="filter.location_id" id="locations" :disabled="!filter.company.id" size="medium" />
    </b-form-group>

    <!-- Campos personalizados de la empresa -->
    <div v-if="filter.company.id">
      <b-row>
        <b-col cols="12" md="6" v-for="field in customFields" :key="field.id">
          <b-form-group>
            <label :for="field.nombre" class="form-label">{{ field.nombre }}</label>
            <input :type="field.tipo" :id="field.nombre" :name="field.nombre" v-model="field.valor"
              :placeholder="field.nombre" class="form-control" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>

// Vuex
import { mapActions, mapState } from "vuex";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import NormalizerLocationsMixin from '@/servicios/productos/ia/mixins/treeselectNormalizer'

export default {
  name: 'TargetContextForm',
  
  components: { Treeselect },

  mixins: [NormalizerLocationsMixin],

  computed: {

    ...mapState("dashboard", {
      globalLoading: 'cargando_datos_select'
    }),
    ...mapState('productos', ['customFields']),
    ...mapState("Reporteinventario", {
      companies: 'listaEmpresas'
    }),

    ...mapState("findings", ["filter"]),
    
  },

  methods: {

    ...mapActions("Reporteinventario", {
      getCompanies: 'getEmpresas'
    }),
    ...mapActions("findings", ["getLocations"]),
    ...mapActions('productos_emp', [
      'getFieldsCustom'
    ]),

    async onHandleSearchCompany(nameCompany) {
      if (!(nameCompany.length >= 1)) return

      await this.getCompanies({ nombre: nameCompany });
    },

    async onChangeCompany(val) {
      if (!val) return

      await this.getLocations(val);
      await this.getFieldsCustom(val);

      this.$emit('company-changed', val)
    },

    onResetCompany() {
      this.$emit('reset-requested')
    },
    
    onChangeLocations(val) {
      this.$emit('locations-changed', val)
    },
    
    onChangeFields() {
      this.$emit('fields-changed', this.fields)
    }
  }
}
</script>

<style scoped></style>